module.exports = __webpack_public_path__ + "img/error-dark.89443db0.svg";